var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadArrow = function SvgDownloadArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 1.625c.483 0 .875.392.875.875v7.888l2.673-2.673a.875.875 0 0 1 1.237 1.237L10.62 13.12a.875.875 0 0 1-1.238 0L5.215 8.952a.875.875 0 1 1 1.237-1.237l2.673 2.673V2.5c0-.483.392-.875.875-.875Zm-7.5 10c.483 0 .875.392.875.875v3.333a.792.792 0 0 0 .792.792h11.666a.791.791 0 0 0 .792-.792V12.5a.875.875 0 0 1 1.75 0v3.333a2.542 2.542 0 0 1-2.542 2.542H4.167a2.542 2.542 0 0 1-2.542-2.542V12.5c0-.483.392-.875.875-.875Z",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadArrow;